<script setup lang="ts">
import { watchImmediate } from '@vueuse/core'
import { logTime } from '@/core/utils'
import IdleTimeout from '../common/IdleTimeout.vue'
import { useIdleFlipup, useIdleFlipupMock } from './IdleFlipup'

const { debugging, timeout, isActivated, doTimeout } = useIdleFlipup()

watchImmediate(isActivated, (isActivatedValue) => {
  if (debugging.value) {
    if (isActivatedValue) {
      console.debug('#samudkoy', 'idle-start', 'flipup', timeout.value, logTime())
    } else {
      console.debug('#samudkoy', 'idle-stop', 'flipup', logTime())
    }
  }
})

function handleIdleTimeout(event: any) {
  if (debugging.value) {
    console.debug('#samudkoy', 'idle-timeout', 'flipup', logTime())
  }
  doTimeout()
}
</script>

<template>
  <idle-timeout v-if="isActivated" :timeout @idle-timeout="handleIdleTimeout" />
</template>
